import pathfinder from '@fiverr-private/pathfinder';
import {gofor} from '@fiverr-private/futile/lib/gofor';

const FETCH_RECOMMENDATIONS_URL = 'lohp_fetch_recommendations';

const getRecommendationsData = (queryParams) => {
    if (!queryParams) {
        throw new Error(`Bad queryParams: ${queryParams}, for ajax recommendations`);
    }
    const uri = pathfinder(FETCH_RECOMMENDATIONS_URL, null, { query: queryParams });
    return gofor(uri)
        .then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                throw new Error(`Bad response for recommendations ajax with queryParams: ${queryParams}. response status is ${response.status}`);
            }
        })
        .then((data) => {
            if (!data || !data.gigs) {
                throw new Error(`No gigs data for recommendations ajax result with queryParams: ${queryParams}`);
            }
            return { ...data };
        });
};

export default getRecommendationsData;
